import { lazy, Suspense } from 'react';

const helperComponents = {
    primalAwakening: lazy(() => import('../primalAwakening/primalAwakening_helper.js')),
};

export function getHelperComponent(gameId) {
    return helperComponents[gameId] || null; // Handle non-existent gameIds
  }
  